module.exports = __webpack_public_path__ + "img/abo2.b22d1e39.jpg";